import { AxiosResponse } from 'axios';
import { apiNestNode, apiV2 } from '../http';
import {
  CreateEmissorInstallationRequestData,
  CreateEmissorInstallationResponse,
  CreateInstallationRequestData,
  CustomerKeys,
  InstallationCheckResponse,
  PauseRequest,
} from '../interfaces/installation/installation';

export function checkInstallations(params: CustomerKeys) {
  return apiV2.get<InstallationCheckResponse>('customers/check', { params });
}

export function pauseAutomation(
  idi: number,
  payload: PauseRequest,
): Promise<AxiosResponse> {
  return apiNestNode.post(`/installation/${idi}/pause-automation`, payload);
}

export function create(
  payload: CreateInstallationRequestData,
  customerId: number,
): Promise<AxiosResponse> {
  return apiNestNode.post('/installation/create', {
    ...payload,
    customer_id: customerId,
  });
}

export function createEmissor(
  payload: CreateEmissorInstallationRequestData,
): Promise<AxiosResponse<CreateEmissorInstallationResponse>> {
  return apiNestNode.post('/installation/create-emissor', payload);
}
